/**
 * «Συσκευές ταμείου»: οι ίδιες τέσσερις κλήσεις από δύο σημεία (25/10/2026) — το πάνελ support / super admin
 * (/api/support/stores/:id/devices…) και το διαχειριστικό του καταστήματος (/api/stores/:id/cashier-devices…).
 * Ίδιοι handlers στον backend (routes/cashierDevices.js), άλλη πύλη. Όλες γυρίζουν το σώμα της απάντησης.
 */
import { supportAPI } from '../../services/supportApi';
import { cashierDevicesAPI } from '../../services/api';

export interface DevicesApi {
  getDevices: (storeId: number) => Promise<any>;
  saveDevices: (storeId: number, uid: string, data: { display: unknown; callerId: unknown }) => Promise<any>;
  deviceCmd: (storeId: number, uid: string, op: string, args?: Record<string, unknown>) => Promise<any>;
  getLastModemCall: (storeId: number, since: string) => Promise<any>;
}

/** Πάνελ support / super admin: ο τεχνικός, για όποιο κατάστημα. */
export const supportDevicesApi: DevicesApi = {
  getDevices: storeId => supportAPI.getDevices(storeId),
  saveDevices: (storeId, uid, data) => supportAPI.saveDevices(storeId, uid, data),
  deviceCmd: (storeId, uid, op, args = {}) => supportAPI.deviceCmd(storeId, uid, op, args),
  getLastModemCall: (storeId, since) => supportAPI.getLastModemCall(storeId, since),
};

/** Διαχειριστικό καταστήματος: μόνο το δικό του κατάστημα (authorizeStore). */
export const storeDevicesApi: DevicesApi = {
  getDevices: storeId => cashierDevicesAPI.list(storeId),
  saveDevices: (storeId, uid, data) => cashierDevicesAPI.save(storeId, uid, data),
  deviceCmd: (storeId, uid, op, args = {}) => cashierDevicesAPI.cmd(storeId, uid, op, args),
  getLastModemCall: (storeId, since) => cashierDevicesAPI.lastCall(storeId, since),
};

/** Ποιος βλέπει το παράθυρο — αλλάζει μόνο τις οδηγίες (π.χ. ποιος αναβαθμίζει τον agent). */
export type DevicesScope = 'support' | 'store';
